import { InjectionToken } from '@angular/core'
import { Converter } from '@spartacus/core'
import { MbReview } from '../../../models'

export const MB_PRODUCT_REVIEW_NORMALIZER = new InjectionToken<Converter<any, MbReview>>('MbProductReviewNormalizer')
export const MB_PRODUCT_REVIEW_SERIALIZER = new InjectionToken<Converter<MbReview, any>>('MbProductReviewSerializer')
